export enum DisplayOnlyTrackedHandleType {
    'PRODUCT' = 'PRODUCT',
    'CATEGORY' = 'CATEGORY',
    'BANNER_LINK' = 'BANNER_LINK',
}
